module.exports = __webpack_public_path__ + "files/guerraoui.13c0d79f5b64105014e1ebfe14cb13ce.pdf";